export const Loader = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'center', margin: '.5rem'}}>
      <div className="loadingio-spinner-bean-eater-hwm2danfbfh">
        <div className="ldio-fgtgkv4yzh6">
          <div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  )
}
